import {SkuCategoryTotalType, SkuFoodCategoryType} from "../../../../common/types";
import {levels} from "../../../../common/optionsForSkuFood";
import {Card} from "antd";


type LevelCategoriesInfoPropsType = {
    data: SkuFoodCategoryType[]
    total: SkuCategoryTotalType[]
    level_category: string
}

export const LevelCategoriesInfo = ({data, total, level_category}: LevelCategoriesInfoPropsType) => {

    // Получаем массив итогов, относящихся к средней цене
    const middlePrice = total.filter((el) => el.address === "Средняя цена")
    // Определяем ключ уровня категории по названию
    const level = Object.keys(levels).find(k => levels[k] === level_category)

    // Функция для определения правильного окончания слова "категория" по числу
    const getCategoryEnding = (count: number) => {
        const lastDigit = count % 10;
        const lastTwoDigits = count % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
            return 'ий';
        }

        if (lastDigit === 1) {
            return 'ия';
        }

        if (lastDigit >= 2 && lastDigit <= 4) {
            return 'ии';
        }

        return 'ий';
    };
    // Отрисовка карточки с информацией по категориям и позициям
    return (
        <>
            {/* Проверяем наличие данных и средней цены, затем отображаем карточку */}
            {data && middlePrice.length && <Card style={{
                color: 'white',
                backgroundColor: '#293133',
                borderRadius: 20,
                paddingLeft: 20,
                paddingRight: 20,
                fontSize: 16,
                height: 564,
                overflowY: 'auto',
                scrollbarWidth: 'none'
            }}>
                <div>{`Левел 1 Самокат - ${data[0].level_1_samokat_count} категор${getCategoryEnding(data[0].level_1_samokat_count)}`}</div>
                <div>{`Левел 3 Самокат - ${data[0].level_3_samokat_count} категор${getCategoryEnding(data[0].level_3_samokat_count)}`}</div>
                <div>{`Категория (1 уровень) - ${data[0].category_1_level_count} категор${getCategoryEnding(data[0].category_1_level_count)}`}</div>
                <div>{`Категория (2 уровень) - ${data[0].category_2_level_count} категор${getCategoryEnding(data[0].category_2_level_count)}`}</div>
                <div>{`Категория (3 уровень) - ${data[0].category_3_level_count} категор${getCategoryEnding(data[0].category_3_level_count)}`}</div>
                {/* Отображение выбранного уровня категории */}
                <div style={{fontSize: 22, fontWeight: 'bold'}}>{`${level_category}`}</div>
                {/* Информация по позициям */}
                <div>{`Собранных позиций - ${middlePrice[0].quantity_positions}`}</div>
                <div>{`Количество уникальных позиций - ${middlePrice[0].quantity_positions}`}</div>
                <div>{`Количество повторов - ${middlePrice[0].repeat_positions}`}</div>
                {/* Горизонтальная линия-разделитель */}
                <div style={{height: 1, backgroundColor: 'white', marginTop: 10, marginBottom: 10}}></div>
                {/* Отображение списка категорий по выбранному уровню, если он есть */}
                {level && data[0].hasOwnProperty(level) && data[0][level as keyof typeof data[0]].toString().split(/,(?=\S)/).map((el) =>
                    <div key={el} style={{
                        wordBreak: 'break-word',
                        hyphens: 'auto'
                    }}>{el.replace('Мелкоштучные хлебные изделия', 'МХИ')}</div>)}
            </Card>}
        </>

    );
};
